// extracted by mini-css-extract-plugin
module.exports = {"popover":"ActionPopover_popover__u_L0M","title":"ActionPopover_title__C3LZy","actions":"ActionPopover_actions__7rUOW","alternateAction":"ActionPopover_alternateAction__JCkbu"};